module.exports = __webpack_public_path__ + "static/media/calculator-nitrogin.04c318aa.png";